/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { GeoProvincesResponse } from '../../models/geo-provinces-response';

export interface GeoControllerGetProvinces$Params {
}

export function geoControllerGetProvinces(http: HttpClient, rootUrl: string, params?: GeoControllerGetProvinces$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GeoProvincesResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, geoControllerGetProvinces.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: GeoProvincesResponse;
      }>;
    })
  );
}

geoControllerGetProvinces.PATH = '/geo/italy/province';
